import { Link, navigate } from "gatsby"
import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"

import { isLoggedIn, signout } from "../api/auth"
import { highContrastStorage, invertColorsStorage } from "../utils/storage"
import Container from "./container"

import "./nav-bar.scss"

const isBrowser = typeof window !== `undefined`

const setRootClassNames = list =>
  isBrowser &&
  (window.document.documentElement.className = list.filter(i => i).join(` `))
setRootClassNames([
  highContrastStorage.get() && highContrastStorage.name,
  invertColorsStorage.get() && invertColorsStorage.name,
])

const NavBar = ({ hideNav }) => {
  const [highContrast, setHighContrast] = useState(highContrastStorage.get())
  const [invertColors, setInvertColors] = useState(invertColorsStorage.get())
  useEffect(() => {
    highContrastStorage.set(highContrast || undefined)
    invertColorsStorage.set(invertColors || undefined)

    setRootClassNames([
      highContrast && highContrastStorage.name,
      invertColors && invertColorsStorage.name,
    ])
  }, [highContrast, invertColors])

  return (
    <nav className="bg-white-0-off" style={{ position: `relative` }}>
      <Container>
        <ul>
          <li className="nav-bar--home">
            <Link to="/" style={{ paddingTop: 0, paddingBottom: 0 }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                width="64"
                height="64"
                role="img"
                aria-label="Home"
                aria-describedby="img-logo--description"
              >
                <desc id="img-logo--description">
                  Logo consisting of calligraphic L and B drawn together in a
                  monogram.
                </desc>
                <path
                  className="fill-black-4"
                  d="M363.507 74.856c-25.587 0-50.292 9.213-74.118 27.64-24.412 19.014-51.172 50.234-80.28 93.66l-23.942 34.682c-22.417-.242-39.729-4.523-51.935-12.852-6.22-4.342-11.033-9.8-14.436-16.373-3.287-6.573-4.93-15.316-4.93-26.232 0-10.914 4.519-21.478 13.556-31.689 4.46-5.043 10.035-9.33 16.725-12.852 6.807-3.52 13.439-5.576 19.894-6.161 6.455-.708 9.683-1.585 9.683-2.643 0-1.403-1.291-2.11-3.874-2.11-17.722 0-33.743 6.63-48.061 19.893-14.085 13.028-21.127 27.229-21.127 42.604s7.395 27.933 22.183 37.675c15.14 9.86 34.682 15.14 58.625 15.845-24.178 32.98-44.6 54.928-61.266 65.842-23.239-8.215-41.607-12.323-55.104-12.323-13.614 0-23.943 1.645-30.985 4.929-3.52 1.524-6.22 3.404-8.098 5.63-1.878 2.231-2.817 4.457-2.817 6.69 0 2.231.763 4.227 2.289 5.987 5.516 6.103 17.663 9.154 36.442 9.154 22.065 0 42.37-4.046 60.914-12.147 36.032 10.798 64.845 16.196 86.44 16.196 23.262-.423 46.524-10.571 62.464-21.83 17.658-12.524 31.175-27.9 40.544-46.143 10.336-20.236 14.352-41.097 12.042-62.569-.276-2.576-.998-3.797-2.165-3.664-1.05.12-1.726 2.068-2.025 5.878-.587 19.776-7.468 39.058-18.133 58.625-6.523 11.966-16.688 24.308-24.541 31.812-15.683 14.985-34.327 26.821-61.442 29.013-5.473.424-10.713.182-15.774 0-3.88-3.011-6.174-7.44-6.814-13.38-1.167-10.852 3.05-24.29 12.658-40.315 7.312-11.913 16.42-23.573 27.253-34.964 11.907-3.471 24.217-8.013 37.024-13.908a354.983 354.983 0 0 0 30.985-16.373c10.21-5.987 19.835-12.323 28.872-19.013 5.348-3.961 10.373-8.024 15.228-12.148.254-.026.504-.12.757-.12 30.924-3.327 53.814.997 68.678 12.974-34.662 23.444-69.967 60.59-105.93 111.44l-38.15 51.9-28.732 37.446c-8.343 10.224-15.648 18.576-21.918 25.035-6.153 6.447-11.808 11.523-16.954 15.263-5.146 3.744-9.982 6.447-14.524 8.116-4.438 1.542-10.341 2.715-17.693 3.507-7.352.792-14.01-.363-20-3.326-6.107-3.005-9.472-7.363-10.087-13.08l-.123-1.053c1.76.986 4.344 1.3 7.729.932 3.267-.363 5.797-1.446 7.605-3.29 1.679-1.953 2.389-4.21 2.113-6.779-.29-2.678-1.44-4.51-3.433-5.472-2.122-1.07-4.119-1.506-5.986-1.306-1.867.241-3.694.64-5.51 1.306-7.022 2.757-10.14 7.824-9.349 15.175.753 7.002 5.002 12.55 12.764 16.673 7.879 4.106 16.907 5.636 27.059 4.541 15.52-1.669 28.143-5.043 37.868-10.105 17.843-9.71 36.075-24.481 54.717-44.312 18.76-19.843 36.627-44.186 53.59-73.043 17.067-28.986 33.455-53.827 49.171-74.523 9.297-12.333 20.918-25.03 34.858-38.097l7.764-6.866a103.867 103.867 0 0 1 7.5-5.933c5.58 5.775 8.857 13.144 9.823 22.13.967 8.986.165 18.054-2.394 27.182-7.024 25.781-23.09 46.571-48.185 62.375-6.64-2.473-12.88-3.41-18.714-2.781-5.835.629-10.465 1.493-13.89 2.57-3.322.95-6.267 2.092-8.838 3.435-2.571 1.336-4.591 2.787-6.074 4.366-1.379 1.445-1.99 3-1.813 4.626.174 1.639 1.705 3.187 4.577 4.65 2.989 1.451 8.574 1.73 16.742.84 8.286-.888 18.208-4.02 29.788-9.4 2.052 2.613 3.444 7.298 4.172 14.066.716 6.652.336 14.085-1.144 22.27-4.674 24.585-16.205 44.58-34.611 60.017-11.466 9.732-22.81 15.201-34.013 16.408-15.988 1.723-24.498-2.19-25.528-11.76-.854-7.936 2.723-17.057 10.704-27.36 3.62-4.758 7.952-9.42 13.01-13.977a120.36 120.36 0 0 1 16.373-12.377c5.858-3.701 11.903-6.784 18.133-9.225 6.347-2.455 11.905-3.924 16.69-4.438 4.901-.484 7.276-1.56 7.112-3.085-.164-1.517-1.475-2.128-3.926-1.868-13.886 1.493-27.835 6.704-41.865 15.65a122.19 122.19 0 0 0-17.499 13.398c-5.37 4.947-9.97 9.99-13.785 15.123-3.699 5.122-6.514 10.198-8.45 15.246-1.949 4.935-2.668 9.734-2.166 14.4.49 4.548 2.946 8.289 7.394 11.233 2.419 1.633 5.565 2.885 9.437 3.768 3.86.768 9.3.774 16.302.018 7.002-.756 14.474-2.558 22.429-5.425 24.657-8.909 43.244-23.248 55.755-43.009 8.38-13.178 11.869-26.236 10.475-39.19-1.632-15.17-7.554-26.397-17.78-33.677 18.412-9.89 33.345-22.483 44.804-37.763 12.384-16.56 17.769-32.298 16.162-47.234-1.658-15.405-8.534-27.772-20.634-37.095 9.692-6.472 20.19-11.553 31.478-15.246 3.867-1.36 6.833-2.268 8.909-2.727 2.063-.605 3.056-1.162 2.992-1.742-.124-1.167-2.1-1.542-5.95-1.13-11.67 1.25-25.81 7.019-42.41 17.304-18.523-11.2-42.63-15.225-72.305-12.06 1.55-1.39 3.205-2.733 4.7-4.136 7.63-7.16 14.202-14.32 19.718-21.478 5.634-7.16 9.977-14.143 13.028-20.95 3.17-6.925 4.753-12.735 4.753-17.43 0-4.699-.704-8.391-2.112-11.091-4.46-8.333-13.497-12.5-27.112-12.5zm-1.057 4.046c2.582 0 4.988.423 7.218 1.403 7.512 3.054 11.267 7.98 11.267 14.788 0 15.375-8.86 32.864-26.583 52.463-5.217 5.818-10.944 11.352-16.901 16.743-24.95 4.287-48.557 13.078-70.808 26.46-12.08 7.32-23.176 15.55-33.291 24.665-4.029 3.628-7.757 7.326-11.303 11.091-3.346.774-6.652 1.464-9.946 2.026 6.572-8.92 13.203-18.544 19.893-28.872l21.126-33.098c35.563-58.45 72.005-87.674 109.328-87.674zm-30.562 90.209a274.54 274.54 0 0 1-41.443 29.153c-17.257 9.988-33.942 17.689-50.051 23.08 1.133-1.106 2.16-2.23 3.327-3.331 27.967-26.228 57.359-42.493 88.167-48.907zm-115.173 63.36c-3.26 3.798-6.366 7.655-9.155 11.584-6.968 9.84-12.19 19.901-15.686 30.193-3.509 10.176-4.895 18.696-4.155 25.58.741 6.885 2.09 11.772 4.05 14.63.545.847 1.151 1.61 1.76 2.359-23.725-1.04-44.702-4.602-62.586-10.985 25.469-13.263 51.113-37.147 76.934-71.653 2.897-.423 5.881-1.113 8.838-1.705zm143.5 64.4c4.9-.484 9.272.056 13.115 1.778-9.804 5.424-18.09 8.495-24.858 9.224-6.769.726-10.297-.363-10.599-3.114-.137-1.282 1.65-2.655 5.388-4.118 1.804-.787 3.865-1.482 6.161-2.08 2.413-.617 6.008-1.174 10.792-1.694zm-296.171 1.572c11.736 0 27.816 2.697 48.238 8.098-13.615 7.394-29.929 11.091-48.943 11.091-7.511 0-13.203-.363-17.076-1.052-12.09-2.231-18.134-5.34-18.134-9.331 0-5.866 11.972-8.802 35.915-8.802z"
                />
              </svg>
            </Link>
          </li>
          {hideNav ? null : isLoggedIn() ? (
            <React.Fragment>
              <li>
                <Link
                  to="/site/toc/"
                  getProps={({ isCurrent }) => ({
                    className: isCurrent ? `fg-black-3` : `fg-black-6`,
                  })}
                >
                  Table of contents
                </Link>
              </li>
              <li>
                <Link
                  to="/site/prolog/"
                  getProps={({ isCurrent }) => ({
                    className: isCurrent ? `fg-black-3` : `fg-black-6`,
                  })}
                >
                  Prolog
                </Link>
              </li>
              <li>
                <Link
                  to="/site/chapters/"
                  getProps={({ isCurrent }) => ({
                    className: isCurrent ? `fg-black-3` : `fg-black-6`,
                  })}
                >
                  Chapters
                </Link>
              </li>
              {/*<li>
                <Link
                  to="/site/guestbook/"
                  getProps={({ isCurrent }) => ({
                    className: isCurrent ? `fg-black-3` : `fg-black-6`,
                  })}
                >
                  Guestbook
                </Link>
              </li>*/}
              <li>
                <Link
                  to="/site/epilog/"
                  getProps={({ isCurrent }) => ({
                    className: isCurrent ? `fg-black-3` : `fg-black-6`,
                  })}
                >
                  Epilog
                </Link>
              </li>
              <li>
                <button
                  className="fg-black-6"
                  onClick={() => {
                    signout()
                    navigate(`/`)
                  }}
                >
                  Logout
                </button>
              </li>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <li>
                <Link
                  to="/login/"
                  getProps={({ isCurrent }) => ({
                    className: isCurrent ? `fg-black-3` : `fg-black-6`,
                  })}
                >
                  Login
                </Link>
              </li>
            </React.Fragment>
          )}
          <li className="nav-bar--accessibility-0 checkbox--styled">
            <input
              type="checkbox"
              aria-label="High contrast mode"
              title="High contrast mode"
              checked={highContrast}
              onChange={() => setHighContrast(!highContrast)}
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              role="presentation"
              height="16"
              width="16"
            >
              <path
                className="fill-black-4"
                d="M7.994.1A.5.5 0 0 0 7.5.605v2.999a.5.5 0 0 0 0 .048.502.502 0 0 0 1.002-.048V.605A.5.5 0 0 0 7.994.1zM2.768 2.268a.5.5 0 0 0-.35.857l2.12 2.12a.5.5 0 0 0 .034.032.5.5 0 0 0 .672-.74L3.125 2.418a.5.5 0 0 0-.357-.15zm10.453 0a.5.5 0 0 0-.344.15l-2.12 2.12a.5.5 0 0 0-.032.034.5.5 0 0 0 .74.672l2.119-2.119a.5.5 0 0 0-.363-.857zM.576 7.5a.5.5 0 0 0 .049 1h2.996a.5.5 0 1 0 0-1H.625a.5.5 0 0 0-.049 0zm11.774 0a.5.5 0 1 0 .048 1h2.998a.5.5 0 1 0 0-1h-2.998a.5.5 0 0 0-.048 0zm-7.457 3.094a.5.5 0 0 0-.342.152l-2.12 2.12a.5.5 0 0 0-.035.032.5.5 0 0 0 .743.672l2.117-2.119a.5.5 0 0 0-.363-.857zm6.2 0a.5.5 0 0 0-.347.857l2.12 2.12a.5.5 0 0 0 .032.034.5.5 0 0 0 .672-.742l-2.119-2.117a.5.5 0 0 0-.357-.152zm-3.099 1.281a.5.5 0 0 0-.494.506v2.996a.5.5 0 0 0 0 .049.502.502 0 0 0 1.002-.049v-2.996a.5.5 0 0 0-.508-.506z"
              />
              <circle
                className={
                  highContrast
                    ? `fill-none stroke-black-4`
                    : `fill-black-4 stroke-none`
                }
                cx="8"
                cy="8"
                r="2.5"
                strokeWidth="1.5"
              />
            </svg>
          </li>
          <li className="nav-bar--accessibility-1 checkbox--styled">
            <input
              type="checkbox"
              aria-label="Invert colors"
              title="Invert colors"
              checked={invertColors}
              onChange={() => setInvertColors(!invertColors)}
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              role="presentation"
              width="16"
              height="16"
            >
              <path
                className="fill-black-4"
                d="M8 0a.69.69 0 0 0-.486.201.5.5 0 0 0-.016.018C6.153 1.697 4.492 3.015 3.123 4.62l-.004.006A6.74 6.74 0 0 0 1.262 9.26a.5.5 0 0 0 0 .002A6.745 6.745 0 0 0 8 16a6.745 6.745 0 0 0 6.738-6.738.5.5 0 0 0 0-.002 6.737 6.737 0 0 0-1.861-4.647.5.5 0 0 0-.004-.002c-1.435-1.486-2.927-2.95-4.387-4.41A.691.691 0 0 0 8 0zm-.25 1.39v13.603a5.728 5.728 0 0 1-3.904-9.68.5.5 0 0 0 .02-.022C5.008 3.945 6.442 2.741 7.75 1.39z"
              />
            </svg>
          </li>
        </ul>
      </Container>
    </nav>
  )
}

NavBar.propTypes = {
  hideNav: PropTypes.bool,
}

export default NavBar
